import React from 'react';
import { getBarcode, getBarcodeIdTicket, getConfiguration, getHiddenTicket } from '../../../data/utils';
import { getLabel } from '../../../InitData';

function PlainTicketHeader(props) {
	
	const ticketData = props.ticketData;
	const conf = getConfiguration();
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment;
	const isCashout = props.isCashout;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const skinProperties = props.skinProperties;
	const user = props.user;
	
	let ticketType = (ticketData.purchaseType === 'systembets' ? 
					    getLabel('printer.plain_ticket.header.system_bets')
					    : 
                        (ticketData.purchaseType === 'singlebets' ? getLabel('printer.plain_ticket.header.single_bets') : getLabel('printer.plain_ticket.header.multiple_bets'))
                      );
	
	ticketType = ticketType + " " + (ticketData.psv? "PSV" : getLabel('printer.plain_ticket.header.fixed_odds'));
	
	if(isCashout){
		ticketType = ticketType + " - " + getLabel('cashout.translation');
	}
	
	// this char will be added to the string "ID" (it means identify string of the ticket) to make clear that this receipt has been
	// print again due to technical issues.
	let charPAR = '';
	if(printAgainTerminalRec){
		let idString = getLabel('printer.plain_ticket.header.id');
		idString = (idString == null || idString === '')? 'IB' : idString;
		charPAR = idString.charAt(idString.length - 1);	
	}
	
	let idTicketToShow = ticketData.idTicket;
	if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
		idTicketToShow = getHiddenTicket(idTicketToShow);
	}
	
	const clearBoth = {clear: "both"};
	
	function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}
	
	let printBarcode = false;
	if(!conf.tad?.bob){
		// ticket must be printed in the header
		if(!terminalCopy){
			printBarcode = frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER';
		}
	}
	

	
	let printShopName = false;
	let shopName = null;
	if(frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER'){
		const mapKey = window.FUNZIONI_TERMINALE? window.FUNZIONI_TERMINALE.NOME_SHOP_SU_RICEVUTA : window.retailFunctions.SHOP_NAME_IN_TICKET;
		printShopName = skinProperties.functions[mapKey];
		if(printShopName){
			if(user.shopDescr != null && user.shopDescr !== ''){
				shopName = user.shopDescr;
			}
		}
		else{
			printShopName = false;
		}
	}
	
	return <>
	{
		frontendType === 'SELF-CASHIER' && window.NUM_CASSA && window.NUM_CASSA != 0 && (
			<div>
				<div style={{marginLeft : "30%", fontSize:"15px"}}>{getLabel('retail.cashier_number')} {window.NUM_CASSA} </div>
			</div>
		)
	}

	{
		aamsEnviroment && frontendType === 'ONLINE' && (
		<div id="header_dogane" className="textcenter">		
			<div className="bold">PROMEMORIA SCOMMESSA TELEMATICA</div>
			<div>Agenzia delle Dogane e dei Monopoli</div>
		</div>)
	}
	
	<div id="header-logos">
		<div id={"customer-logo" + (props.aamsLogo != null? "" : "-solo")}>
		{
			props.customerLogo != null && props.customerLogo.length > 0 && (
					<img src={props.customerLogo} />
			)
			
		}
		</div>
		{
			props.aamsLogo != null &&(
					<div id="aams-logo">
						<img src={props.aamsLogo} />
					</div>
			)
		}
		<div style={clearBoth}></div>
	
	</div>
	
	{
		printBarcode
		&& (
 			<div className="barcode-top"> 
 				<img style={{ height: "50px", width:"100%"}} src={getBarcode(getBarcodeIdTicket(ticketData.idTicket, printAgainTerminalRec), 1, false)} />
 			</div>
		)
	}
	
	{
		aamsEnviroment?
		(
			<div id="first-table">
				<div>
					<div className="td-40 left">{getLabel('printer.plain_ticket.header.cc')} : {ticketData.cc} </div>
					{
						(frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER') &&
						<>
							<div className="td-35 left"> {getLabel('printer.plain_ticket.header.pv')} : {ticketData.pv} </div>
							<div className="td-25 left textright"> {getLabel('printer.plain_ticket.header.tm')}: {ticketData.tm} </div> 
						</>
					}
					{
						frontendType === 'ONLINE' &&(
								<div className="td-60 left textleft"> {getLabel('printer.plain_ticket.header.cf')}: {ticketData.cf}</div> 					
						)
					}
					<div style={clearBoth}></div>
				</div>
				
				{
					(frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER') && printShopName && (	
						<div>
							<div className="td-100 left"> {getLabel('printer.plain_ticket.header.nc')} : {shopName} </div>
							<div style={clearBoth}></div>
						</div>)
				}
				<div>
					<div className="td-40 left">{getLabel('printer.plain_ticket.header.tg')} : {ticketData.tg}</div>
					<div className="td-35 left">{getLabel('printer.plain_ticket.header.ge')} : {ticketData.ge}</div>
					<div className="td-25 left textright">{getLabel('printer.plain_ticket.header.oe')} : {ticketData.oe}</div>
					<div style={clearBoth}></div>
				</div>
				
				<div>
					<div className="td-65 left">{getLabel('printer.plain_ticket.header.id') + charPAR}: {generateIdTicketWithBars(idTicketToShow)}</div>
					<div className="td-35 left textright" >{getLabel('printer.plain_ticket.header.gr')} : {ticketData.gr}</div>
					<div style={clearBoth}></div>
				</div>
			</div>
		)
		:
		(
			<div id="first-table-foreign-countries"  style={{marginTop:"4px"}}>
				<div>
					<div className="td-100 uppercase">{getLabel('printer.bordered_ticket.body.issue_date')}: {ticketData.ge} {ticketData.oe}</div>
				</div>
			 	{
			 		frontendType === 'TERMINAL' && <>
			 			<div>{getLabel('printer.plain_ticket.header.tm')} {ticketData.tm}</div>
			 			<div>{getLabel('printer.plain_ticket.header.operator')} {ticketData.operator}</div>
						<div style={{marginTop:"2px"}}>
							<div className="td-100 uppercase">{getLabel('printer.plain_ticket.header.agency')} {ticketData.agency}</div>
						</div>
			 		</>
			 	}
				<div className="textcenter id_ticket_footer">{getLabel('printer.plain_ticket.header.id') + charPAR}: {idTicketToShow.length > 10? generateIdTicketWithBars(idTicketToShow) : idTicketToShow }</div>
			</div>
		)
	}
	
	<div className="separator"></div>
	
	<div>
		<div className="textcenter td-100 ticketType uppercase">{ticketType}</div>
		{
			(frontendType === 'ONLINE' || terminalCopy) && (
				<div className="textcenter td-100 copy">{getLabel('printer.plain_ticket.header.copy')}</div>
			)
		}
	</div>
	<div className="separator"></div>
	
	</>
}

export default PlainTicketHeader;